import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyCrater(heights, resolution, layoutSize, feature, noise) {
    const strength = feature.strength ?? 1;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const warp = noise.noise2(u * 3 + feature.seed * 0.01, v * 3) * 0.06;
        const radius = Math.hypot(u + warp, v);
        if (radius > 1.08) return;

        const bowl = Math.max(0, 1 - radius);
        const rim = Math.exp(-((radius - 0.78) * (radius - 0.78)) / 0.012);
        const delta = (rim * 0.42 - bowl * bowl) * feature.height * strength;
        writeHeight(heights, idx, clampHeight(heights[idx] + delta));
    });
}
